import React, { useMemo } from 'react';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  getLoanSelectedIdsPath,
  getLeaseSelectedIdsPath,
  InventoryIncentivesModel,
} from 'client/data/models/inventory-incentives';
import {
  getLoanConditionalIncentives,
  getLoanPrimaryIncentives,
  getLeaseConditionalIncentives,
  getLeasePrimaryIncentives,
  getSelectedIncentives,
} from 'site-modules/shared/utils/incentives/incentives-service';

const stateToPropsConfig = {
  selectedLoanIncentivesIds: bindToPath(
    ({ vinData }) => getLoanSelectedIdsPath(vinData?.vin),
    InventoryIncentivesModel,
    null,
    false
  ),
  selectedLeaseIncentivesIds: bindToPath(
    ({ vinData }) => getLeaseSelectedIdsPath(vinData?.vin),
    InventoryIncentivesModel,
    null,
    false
  ),
};

export const withIncentives = component => {
  const ChildComponent = component;

  const WithIncentives = props => {
    const { vinData, selectedLoanIncentivesIds, selectedLeaseIncentivesIds } = props;

    const selectedLoanIncentives = useMemo(
      () => (vinData && getSelectedIncentives({ vinData, ids: selectedLoanIncentivesIds })) || [],
      [selectedLoanIncentivesIds, vinData]
    );

    const selectedLeaseIncentives = useMemo(
      () => (vinData && getSelectedIncentives({ vinData, ids: selectedLeaseIncentivesIds })) || [],
      [selectedLeaseIncentivesIds, vinData]
    );

    return (
      <ChildComponent
        {...props}
        selectedLoanIncentives={selectedLoanIncentives}
        selectedLeaseIncentives={selectedLeaseIncentives}
        primaryLoanIncentives={getLoanPrimaryIncentives({ vinData })}
        primaryLeaseIncentives={getLeasePrimaryIncentives({ vinData })}
        conditionalLoanIncentives={getLoanConditionalIncentives({ vinData })}
        conditionalLeaseIncentives={getLeaseConditionalIncentives({ vinData })}
      />
    );
  };

  WithIncentives.displayName = `withIncentives(${component.displayName || component.name})`;

  return connectToModel(WithIncentives, stateToPropsConfig);
};
